import styled from 'styled-components';
import { Grid } from '@simplywallst/ui-core';

export const ModalWrapper = styled('div')`
  max-width: 500px;
  margin: 0 auto;
`;
export const GridBox = styled(Grid)`
  margin: 12px 0;
  text-align: center;
`;

export const ResetLink = styled('a')`
  cursor: pointer;
  ${({ theme }) => theme.typography.xSmall}
  color: ${({ theme }) => theme.color.brand01};
  text-decoration: none;
`;
